module.exports = __webpack_public_path__ + "static/media/changjie-logo.1a7b4be209c71197378cf32706c832cf.png";